angular
	.module 'App.Module.Configuration', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'configurations',
				url: '/configurations',
				views:
					"main@":
						controller: 'ConfigurationController'
						controllerAs: 'vm'
						templateUrl: '@app/configuration/configuration.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					configurations: (ConfigurationRepository) ->
						return ConfigurationRepository.getPublicEntities()
				data:
					pageTitle: 'Configurations'
					hideSubMenu: true
					restrict: "Backoffice.TopMenu.Setting.Configurations"
					restrictForUser: true
